import { ArrowUpRight } from "lucide-react";
import { DIVISIONS } from "@/data/content";
import { Reveal, SectionHeader } from "@/components/motion";

export const Divisions = ({ index = "04" }) => (
  <section className="border-t border-charcoal/10" data-testid="divisions-section">
    <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
      <SectionHeader
        index={index}
        overline="Corporate Structure"
        title="Specialized Solutions Under One Corporate Platform"
      />
      <Reveal delay={0.1}>
        <p className="mt-6 max-w-2xl leading-relaxed text-charcoal/70">
          Iconicho, LLC is the corporate platform behind specialized business
          offerings — each focused on a distinct service area, backed by one
          company.
        </p>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {DIVISIONS.map((d, i) => (
          <Reveal key={d.name} delay={0.1 + i * 0.08} className="h-full">
            <a
              href={d.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={d.testId}
              className="group flex h-full flex-col justify-between rounded-sm border border-charcoal/10 bg-white p-10 transition-colors duration-300 hover:border-gold/60"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className="font-heading text-xs font-bold tracking-[0.25em] text-gold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-charcoal/30 transition-[color,transform] duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold" />
                </div>
                <h3 className="mt-6 font-heading text-2xl font-bold tracking-tight text-navy">
                  {d.name}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/70">
                  {d.description}
                </p>
              </div>
              <span className="mt-10 inline-flex items-center text-sm font-medium text-navy">
                <span className="border-b border-gold/50 pb-0.5 transition-colors duration-300 group-hover:border-gold">
                  {d.cta}
                </span>
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
